import { NUMBER_MASK } from '@/modules/projects/components/Workbench/accounts'
import type { SeriesPoint, StartingAccount } from '../model/portfolioOverview'
import { joinWithAnd } from '../portfolioText'

// The point where one or more accounts join the total because their statements start there.
export interface AccountStart {
  position: number
  accounts: StartingAccount[]
}

const startedAt = (series: SeriesPoint[], index: number) =>
  series[index - 1].notStarted
    .filter(
      (account) =>
        !series[index].notStarted.some(
          (later) => later.accountId === account.accountId,
        ),
    )
    .sort((first, second) =>
      first.accountName.localeCompare(second.accountName),
    )

// Every point after the first where an account's statements start, so a step up in the total is
// not read as growth.
export const accountStarts = (series: SeriesPoint[]): AccountStart[] =>
  series.flatMap((_point, index) => {
    if (index === 0) return []
    const accounts = startedAt(series, index)
    return accounts.length === 0 ? [] : [{ position: index, accounts }]
  })

const shortName = (account: StartingAccount) =>
  account.last4 ? `${NUMBER_MASK} ${account.last4}` : account.accountName

// "•• 9879 starts", "•• 0583 and •• 0608 start"
export const startLabel = (start: AccountStart): string => {
  const verb = start.accounts.length === 1 ? 'starts' : 'start'
  return `${joinWithAnd(start.accounts.map(shortName))} ${verb}`
}
